import { getContentfulClient } from "../../lib/contentful/contentfulClient"
import { reportErrorMessage } from "../../utils/ErrorReporting"
import styled from "styled-components"
import React, { FC, useEffect, useState } from "react"
import { Checkbox } from "components/views/atoms/Checkbox"
import { getIsDynamicContentToggleToolOpen } from "../../reducers/application"
import { toggleDymamicContentTogglesTool } from "../../actions/testUserActions"
import { useSelector, useDispatch } from "react-redux"
// @ts-ignore
import { lightGray, mineralGrey } from "css/variables/_colors.scss"
import { Button } from "components/views/atoms/buttons/Button"
import { RootState } from "reducers"
import { IAttribute } from "contentful-types"
import { useContentfulConditions } from "./hooks/useContentfulConditions"
type DynamicContentTogglesProps = {}

const ToggleLabel = styled.label`
  width: 15rem;
  cursor: pointer;
`
const ToggleDiv = styled.div`
  padding: 0.25rem 1rem 0.25rem 0.25rem;
  background-color: ${lightGray};
  border-bottom: 0.1rem solid white;
`
const ToggleDescLink = styled.a`
  float: right;
  font-size: 1rem;
  cursor: pointer;
`
const ToggleModal = styled.div`
  border: .15rem solid ${mineralGrey};
  border-radius:.5rem;
  padding: 1rem;
  width: 20rem;
  overflow-auto;
  opacity: .85;
  position: fixed;
  top:1rem;
  left:1rem;
  z-index:10;
`
const TogglesDiv = styled.div`
  margin-top:.5rem;
  max-height: 20rem;
  overflow-auto;
  font-size:1rem;
`

export const DynamicContentToggles: FC<DynamicContentTogglesProps> = () => {
  const [attributes, setAttributes] = useState<IAttribute[]>(null)
  const [showAsKeys, setShowAsKeys] = useState<boolean>(false)
  const conditionMap = useContentfulConditions()
  const dispatch = useDispatch()

  const { isDynamicContentToggleToolOpen } = useSelector((state: RootState) => ({
    isDynamicContentToggleToolOpen: getIsDynamicContentToggleToolOpen(state)
  }))

  function toggleShowAsKeys(): void {
    setShowAsKeys(!showAsKeys)
  }

  const getAttributes = async (): Promise<IAttribute[]> => {
    const client = getContentfulClient()
    const { items } = await client.getEntries({ content_type: "attribute" })
    return items as IAttribute[]
  }

  useEffect(() => {
    async function loadAttributes(): Promise<void> {
      const dynamicAttribs = await getAttributes()
      setAttributes(dynamicAttribs.filter(({ fields: { key } }) => typeof conditionMap[key] !== "undefined"))
      dynamicAttribs
        .filter(({ fields: { key } }) => typeof conditionMap[key] === "undefined")
        .forEach(({ fields: { key } }) => reportErrorMessage(`No mapping for Contentful attribute with key: ${key}`))
    }
    if (!attributes) {
      loadAttributes()
    }
  }, [])

  if (attributes) {
    return isDynamicContentToggleToolOpen ? (
      <ToggleModal className={`bg-white  DynamicContentToggles`}>
        <button
          className={`fr pointer bw0 bg-white black-60 hover-black animate-all`}
          onClick={() => dispatch(toggleDymamicContentTogglesTool())}
          style={{ lineHeight: 0 }}
        >
          <img alt="close" src="/images/icn-close-modal.svg" />
        </button>
        <Button onClick={toggleShowAsKeys}>{showAsKeys ? "Display as names" : "Display as keys"}</Button>
        <TogglesDiv className={`flex flex-column overflow-y-auto br3`}>
          {attributes.length
            ? attributes.sort(showAsKeys ? sortByKey : sortByName).map((attrib) => (
                <AttribDisplay
                  attribute={attrib}
                  showAsKeys={showAsKeys}
                  key={`test_${attrib.fields.key}`}
                  onChange={() => {
                    conditionMap[attrib.fields.key].toggle()
                  }}
                  isOn={conditionMap[attrib.fields.key]?.value}
                />
              ))
            : "No Toggles Available"}
        </TogglesDiv>
      </ToggleModal>
    ) : null
  } else {
    return null
  }
}
type DynamicAttributeProps = {
  attribute: IAttribute
  showAsKeys: boolean
  onChange: Function
  isOn: boolean
}
const AttribDisplay: FC<DynamicAttributeProps> = ({
  attribute: {
    fields: { name, description, key }
  },
  showAsKeys,
  onChange,
  isOn
}) => {
  const [showDescription, setShowDescription] = useState<boolean>(false)
  function toggleDescription(): void {
    setShowDescription(!showDescription)
  }
  return (
    <ToggleDiv>
      <div>
        <ToggleLabel>
          <Checkbox checked={isOn} onChange={onChange} size="20px" /> {showAsKeys ? key : name}
        </ToggleLabel>
        {description && (
          <ToggleDescLink onClick={toggleDescription}>
            <img
              className={`animate-all vmid ${showDescription ? "rotate-180" : ""}`}
              alt={showDescription ? "close" : "open"}
              src={`/images/icn-upwards-arrow.png`}
              style={{ minWidth: "17px" }}
            />
          </ToggleDescLink>
        )}
      </div>
      {showDescription && <span>{description}</span>}
    </ToggleDiv>
  )
}

const sortByName = ({ fields: { name: nameA } }, { fields: { name: nameB } }) => {
  if (nameA < nameB) {
    return -1
  }
  if (nameA > nameB) {
    return 1
  }
  return 0
}
const sortByKey = ({ fields: { key: keyA } }, { fields: { key: keyB } }) => {
  if (keyA < keyB) {
    return -1
  }
  if (keyA > keyB) {
    return 1
  }
  return 0
}
